import {
  DELETE_CHAT_MESSAGES,
  DELETE_CHAT_MESSAGES_FAILED,
  DELETE_CHAT_MESSAGES_SUCCESS,
  GET_CHAT_USERS,
  GET_CHAT_USERS_FAILED,
  GET_CHAT_USERS_SUCCESS,
  GET_COMMENT_BOARD,
  GET_COMMENT_BOARD_FAILED,
  GET_COMMENT_BOARD_LIST,
  GET_COMMENT_BOARD_LIST_FAILED,
  GET_COMMENT_BOARD_LIST_SUCCESS,
  GET_COMMENT_BOARD_SUCCESS,
  INIT_CHAT_SESSION,
  INIT_CHAT_SESSION_SUCCESS,
  LOAD_CHAT_MESSAGES,
  LOAD_CHAT_MESSAGES_FAILED,
  LOAD_CHAT_MESSAGES_SUCCESS,
  NEW_MESSAGE,
  RESET_COMMENT_BOARD,
  RESET_COMMENT_BOARD_LIST,
  SAVE_DIALOG,
  SAVE_MESSAGES,
  SAVE_SESSION,
  SEND_CHAT_NOTIFICATION,
  SEND_MESSAGE_WITH_MEDIA,
  SEND_MESSAGE_WITH_MEDIA_FAILED,
  SEND_MESSAGE_WITH_MEDIA_SUCCESS,
  SET_SESSION_STATUS,
  UPDATE_COMMENT_BOARD_LAYOUT,
  UPDATE_COMMENT_BOARD_LAYOUT_FAILED,
  UPDATE_COMMENT_BOARD_LAYOUT_SUCCESS,
  UPLOAD_IMAGES,
  UPLOAD_IMAGES_FAILED,
  UPLOAD_IMAGES_SUCCESS,
  UPLOAD_VIDEOS,
  UPLOAD_VIDEOS_FAILED,
  UPLOAD_VIDEOS_SUCCESS,
} from "./actionTypes"

export const getCommentBoard = params => ({
  type: GET_COMMENT_BOARD,
  payload: params,
})

export const getCommentBoardSuccess = response => ({
  type: GET_COMMENT_BOARD_SUCCESS,
  payload: response,
})

export const getCommentBoardFaield = error => ({
  type: GET_COMMENT_BOARD_FAILED,
  payload: error,
})

export const resetCommentBoard = () => ({
  type: RESET_COMMENT_BOARD,
  payload: {},
})

export const updateCommentBoardLayout = params => ({
  type: UPDATE_COMMENT_BOARD_LAYOUT,
  payload: params,
})

export const updateCommentBoardLayoutSuccess = response => ({
  type: UPDATE_COMMENT_BOARD_LAYOUT_SUCCESS,
  payload: response,
})

export const updateCommentBoardLayoutFailed = error => ({
  type: UPDATE_COMMENT_BOARD_LAYOUT_FAILED,
  payload: error,
})

export const getChatUsers = params => ({
  type: GET_CHAT_USERS,
  payload: params,
})

export const getChatUsersSuccess = response => ({
  type: GET_CHAT_USERS_SUCCESS,
  payload: response,
})

export const getChatUsersFailed = error => ({
  type: GET_CHAT_USERS_FAILED,
  payload: error,
})

export const initChatSession = params => ({
  type: INIT_CHAT_SESSION,
  payload: params,
})

export const saveSession = session => ({
  type: SAVE_SESSION,
  payload: session,
})

export const saveMessages = messages => ({
  type: SAVE_MESSAGES,
  payload: messages,
})

export const saveDialog = dialog => ({
  type: SAVE_DIALOG,
  payload: dialog,
})

export const newMessage = message => ({
  type: NEW_MESSAGE,
  payload: message,
})

export const initChatSessionSuccess = () => ({
  type: INIT_CHAT_SESSION_SUCCESS,
  payload: {},
})

export const loadChatMessages = params => ({
  type: LOAD_CHAT_MESSAGES,
  payload: params,
})

export const loadChatMessagesSuccess = response => ({
  type: LOAD_CHAT_MESSAGES_SUCCESS,
  payload: response,
})

export const loadChatMessagesFailed = error => ({
  type: LOAD_CHAT_MESSAGES_FAILED,
  payload: error,
})

export const deleteChatMessages = params => {
  return {
    type: DELETE_CHAT_MESSAGES,
    payload: params,

  };
};


export const deleteChatMessagesSuccess = response => {
  return {
    type: DELETE_CHAT_MESSAGES_SUCCESS,
    payload: response,
  }
}

export const deleteChatMessagesFailed = error => {
  return {
    type: DELETE_CHAT_MESSAGES_FAILED,
    payload: error,
  }
}

export const uploadImages = params => ({
  type: UPLOAD_IMAGES,
  payload: params,
})

export const uploadImagesSuccess = response => ({
  type: UPLOAD_IMAGES_SUCCESS,
  payload: response,
})

export const uploadImagesFailed = error => ({
  type: UPLOAD_IMAGES_FAILED,
  payload: error,
})

export const uploadVideos = params => ({
  type: UPLOAD_VIDEOS,
  payload: params,
})

export const uploadVideosSuccess = response => ({
  type: UPLOAD_VIDEOS_SUCCESS,
  payload: response,
})

export const uploadVideosFailed = error => ({
  type: UPLOAD_VIDEOS_FAILED,
  payload: error,
})

export const sendChatNotification = params => ({
  type: SEND_CHAT_NOTIFICATION,
  payload: params,
})

export const setSessionStatus = params => ({
  type: SET_SESSION_STATUS,
  payload: params,
})

export const getCommentBoardList = params => ({
  type: GET_COMMENT_BOARD_LIST,
  payload: params,
})

export const getCommentBoardListSuccess = response => ({
  type: GET_COMMENT_BOARD_LIST_SUCCESS,
  payload: response,
})

export const getCommentBoardListFailed = error => ({
  type: GET_COMMENT_BOARD_LIST_FAILED,
  payload: error,
})

export const resetCommentBoardList = () => ({
  type: RESET_COMMENT_BOARD_LIST,
  payload: {},
})

export const sendMessageWithMedia = (
  file,
  mediaType,
  media,
  message,
  userId,
  event_id,
  menu_item_id,
  vendor_id,
  xmpp_room_jid
) => ({
  type: SEND_MESSAGE_WITH_MEDIA,
  payload: {
    file,
    mediaType,
    media,
    message,
    userId,
    event_id,
    menu_item_id,
    vendor_id,
    xmpp_room_jid,
  },
})

export const sendMessageWithMediaSuccess = response => ({
  type: SEND_MESSAGE_WITH_MEDIA_SUCCESS,
  payload: response,
})

export const sendMessageWithMediaFailed = error => ({
  type: SEND_MESSAGE_WITH_MEDIA_FAILED,
  payload: error,
})
